export default {
  employee: 'Nhân viên'
};
